"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestCache = void 0;
const sha256_1 = __importDefault(require("crypto-js/sha256"));
class RequestCache {
    constructor() {
        this.getStorageKey = (key) => {
            return `clubAdmin:cachedRequest:${(0, sha256_1.default)(key.join(':')).toString()}`;
        };
        this.add = (key, data) => {
            const storageKey = this.getStorageKey(key);
            sessionStorage.setItem(storageKey, JSON.stringify(data));
            console.info('[ClubAdmin.RequestCache.add]', storageKey);
        };
        this.get = (key) => {
            const storageKey = this.getStorageKey(key);
            const value = sessionStorage.getItem(storageKey);
            let parsedValue = null;
            if (value) {
                parsedValue = JSON.parse(value);
                console.info('[ClubAdmin.RequestCache.get]', storageKey);
            }
            return parsedValue;
        };
    }
}
exports.RequestCache = RequestCache;
const cachedRequest = async (requestFn, key) => {
    const requestCache = new RequestCache();
    const cachedResponse = requestCache.get(key);
    if (cachedResponse !== null) {
        return cachedResponse;
    }
    const response = await requestFn();
    requestCache.add(key, response);
    return response;
};
exports.default = cachedRequest;
